module.exports = __webpack_public_path__ + "img/sign-19.d0f675a5.jpg";